import { useState as r, useEffect as l } from "react";
function d() {
  const [n, o] = r(!1), { style: s } = document.documentElement;
  function t() {
    n ? i() : u();
  }
  function u() {
    s.setProperty("--button-bar-shift", "380px"), o(!0);
  }
  function i() {
    s.setProperty("--button-bar-shift", "120px"), o(!1);
  }
  return {
    toggleShift: t,
    revertShift: i
  };
}
function e(n) {
  return window.matchMedia(n).matches;
}
function b({
  desktop: n = 1024,
  tablet: o = 768
} = {}) {
  const s = `(min-width: ${n}px)`, t = `(min-width: ${o}px)`, [u, i] = r(
    e(s)
  ), [a, c] = r(e(t)), [f, p] = r(!e(t));
  return l(() => {
    const h = window.addEventListener("resize", () => {
      i(e(s)), c(e(t)), p(!e(t));
    });
    return () => {
      window.removeEventListener("resize", h);
    };
  }, []), {
    isDesktop: u,
    isTablet: a,
    isMobile: f
  };
}
export {
  b as a,
  d as u
};
